<template>
  <div>
    <div class="title-bar">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '默认标题'
    }
  }
}
</script>
<style scoped lang="less">
.title-bar {
  font-size: 32px;
  font-weight: 500;
  color: #000000;
  margin-top: 26px;
  margin-bottom: 26px;

}
</style>